// removed by extract-text-webpack-plugin
module.exports = {"wrapper-toast":"magazines_3EZul","wrapper-toast__type-success":"magazines_-cDP5","wrapper-toast__type-info":"magazines_13SAB","wrapper-toast__type-error":"magazines_3-xAj","wrapper-toast__position-top":"magazines_2mraN","toastTop":"magazines_1YxKy","wrapper-toast__position-top-right":"magazines_UTewW","wrapper-toast__position-left":"magazines_kH6Iz","wrapper-toast__position-bottom-right":"magazines_2riru","toastBottom":"magazines_2BZQx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Toast/styles.scss
// module id = 1019
// module chunks = 1